<template>
<v-card flat>
  <v-card-text class='text-xs-center' >
    <v-icon class='mt-4 pt-4' style='font-size:60px;' color='green'>check_circle</v-icon>
    <h3 class='subheading mt-4' >Invoice created</h3>
    <p v-if='value' >{{value.title}}</p>
    <v-list >
      <v-subheader>Next Steps:</v-subheader>
      <template v-for='action in actions' >
        <v-list-tile
          @click='action.onclick(value)'
          :key='action.title' >
          <v-list-tile-avatar v-if='action.icon' >
            <v-icon >{{action.icon}}</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title>{{action.title}}</v-list-tile-title>
            <v-list-tile-sub-title v-if='action.subtitle'>
              {{action.subtitle}}
            </v-list-tile-sub-title>
          </v-list-tile-content>
          <v-list-tile-action>
            <v-icon>chevron_right</v-icon>
          </v-list-tile-action>
        </v-list-tile>
        <v-divider :key='`d-${action.title}`' ></v-divider>
      </template>
    </v-list>
  </v-card-text>
</v-card>
</template>

<script>
import InvoiceMixin from '@/mixins/invoice'
export default {
  name: 'InvoiceSuccess',
  mixins: [InvoiceMixin],
  props: {
    value: { type: Object },
    withNextSteps: { type: Boolean, default: false }
  },
  data () {
    let vm = this
    return {
      actions: [
        {
          title: 'Send',
          icon: 'send',
          onclick: (invoice) => {
            vm.invoiceEvents.send(invoice)
          }
            // this.$emit('done')
            // this.$store.dispatch(
            //   'SET_SPACE',
            //   [
            //     'globalDialog',
            //     'SendInvoice',
            //     'Send',
            //     {
            //       invoice: invoice,
            //       client: vm.client
            //     },
            //     {},
            //     false
            //   ]
            // )
        },
        {
          title: 'Share',
          icon: 'share',
          onclick: (invoice) => {
            vm.invoiceEvents.share(invoice)
          }
        },
        {
          title: 'View',
          icon: 'open_in_new',
          onclick: (invoice) => {
            // this.$emit('done')
            let url = `${this.$invoiceguru.baseUrl}/${invoice.get_view_url}`
            // this.$router.push({path: url})
            window.open(url, '_blank')
          }
        },
        {
          title: 'Edit',
          icon: 'edit',
          onclick: (invoice) => {
            this.$emit('done')
            this.$router.push({ path: '/invoices/' + invoice.id })
            this.$store.dispatch('HIDE_SPACE', 'globalDialog')
          }
        },
        {
          title: 'Add another',
          subtitle: 'Create another invoice',
          icon: 'add',
          onclick: (invoice) => {
            // this.$emit('done')
            this.$emit('next')
          }
        },
        {
          title: 'Done',
          subtitle: 'Return to what you were doing',
          icon: 'done',
          onclick: (invoice) => {
            this.$emit('done')
            this.$store.dispatch('HIDE_SPACE', 'globalDialog')
          }
        }
      ]
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// success.vue?6a16cb4c